export default class LocalStorageService {
    static logOut() {
        LocalStorageService.removeAuthToken();
        LocalStorageService.removeSchematic();
    }

    static getAuthToken() {
        return localStorage.getItem('cyny_app_token');
    }

    static setAuthToken(token) {
        localStorage.setItem('cyny_app_token', token);
    }

    static removeAuthToken() {
        localStorage.removeItem('cyny_app_token');
    }

    static getSchematicId() {
        return +localStorage.getItem('schematic_id');
    }

    static getSchematicTypeId() {
        return +localStorage.getItem('schematic_type_id');
    }

    static setSchematic(schematicData) {
        localStorage.setItem('schematic_id', schematicData.id);
        localStorage.setItem('schematic_type_id', schematicData.schematic_type_id);
    }

    static removeSchematic() {
        localStorage.removeItem('schematic_id');
        localStorage.removeItem('schematic_type_id');
    }

    static isHistoryLostWarningShown() {
        return localStorage.getItem('history_lost_warning');
    }

    static setHistoryLostWarningShown() {
        localStorage.setItem('history_lost_warning', true);
    }
}
